<template>
    <div class="container">
        <van-nav-bar style="background: #F7333A;" title="活动抽奖" left-arrow fixed  
          @click-left="back"
          />
        <div class="lucky-wheel">
            <div class="wheel-main">
                <div class="wheel-pointer-box">
                    <div class="wheel-pointer"></div>
                </div>
                <div class="wheel-bg" :style="{transform:rotate_angle,transition:rotate_transition}">
                    <div class="prize-list">
                        <div class="prize-item" v-for="(item,index) in prize_list" :key="index">
                            <div class="prize-pic">
                                <img :src="item.icon">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lucky-btn" :class="{'btn-filter':!this.click_flag}" @click="rotate_handle()">
                点&nbsp;&nbsp;击&nbsp;&nbsp;抽&nbsp;&nbsp;奖
            </div>
        </div>
        <div class="toast" v-show="toast_control">
            <div class="toast-container">
                <!-- <img :src="toast_pictrue" class="toast-picture"> -->
                <div class="close" @click="close_toast()"></div>
                <div class="toast-title">
                    {{toast_title}}
                </div>
                <div class="toast-btn">
                    <div class="toast-cancel" @click="close_toast">关闭</div>
                </div>
            </div>
        </div>
        <div class="toast-mask" v-show="toast_control"></div>
    </div>
</template>
<script>
    import { NavBar } from "vant";
    export default {
        data() {
            return {
                toast_title:'',//弹出提示
                prize_list: [
                    {
                        icon: require("../../assets/img/awards_100.png"), // 奖品图片
                        count: 100, // 奖品数量
                        name: "元优惠券"// 奖品名称
                    },
                    {
                        icon: require("../../assets/img/awards_1.png"),
                        count: 1,
                        name: "积分"
                    },
                    {
                        icon: require("../../assets/img/awards_20.png"),
                        count: 20,
                        name: "元优惠券"
                    },
                    {
                        icon: require("../../assets/img/awards_10.png"),
                        count: 10,
                        name: "积分"
                    },
                    {
                        icon: require("../../assets/img/awards_50.png"),
                        count: 50,
                        name: "元优惠券"
                    },
                    {
                        icon: require("../../assets/img/awards_5.png"),
                        count: 5,
                        name: "积分"
                    }
                ], //奖品列表
                toast_control: false, //抽奖结果弹出框控制器
                start_rotating_degree: 0, //初始旋转角度
                rotate_angle: 0, //将要旋转的角度
                rotate_transition: "transform 6s ease-in-out", //初始化选中的过度属性控制
                click_flag: true, //是否可以旋转抽奖
                result_index: 0,//转动到下标奖品
            };
        },
        components: {
            [NavBar.name]: NavBar
        },
        methods: {
            back() {
              history.back();
            },
            //开始抽奖
            rotate_handle() {
                if (!this.click_flag) return;
                this.reduceIntegral();
            },
            rotating(index) {
                this.click_flag = false; // 旋转结束前，不允许再次触发
                var during_time = 6; // 默认为1s
                var result_angle = [360, 300,240, 180, 120, 60]; //最终会旋转到下标的位置所需要的度数
                var rand_circle = 6; // 附加多转几圈，2-3
                // 转动盘子
                var rotate_angle =
                    this.start_rotating_degree +
                    rand_circle * 360 +
                    result_angle[index] 
                    this.start_rotating_degree % 360;
                this.start_rotating_degree = rotate_angle -  result_angle[index];
                this.rotate_angle = "rotate(" + rotate_angle + "deg)";
                var that = this;
                // 旋转结束后，允许再次触发
                setTimeout(function () {
                    that.click_flag = true;
                    that.game_over();
                }, during_time * 1000 + 1500); // 延时，保证转盘转完
            },
            // 抽奖
            reduceIntegral() {
                var that = this;
                let userid = localStorage.getItem("userId");
                this.$api.post(that.jumuc.userCenter.turnTableGameFree,{source: 1, userId: userid},successRes=>{
                    if (successRes.errCode == 2101) {
                        that.toast_title = '今日抽奖次数已用完，欢迎明日再来！'
                        that.game_over();
                    }else if (successRes.errCode == 21010) {
                        that.toast_title = '活动尚未开始,敬请期待！'
                        that.game_over();
                    }else {
                        that.result_index = successRes.data.zsIntegral;
                        if(successRes.success){
                            that.toast_title = "恭喜获得" + that.prize_list[that.result_index].count + that.prize_list[that.result_index].name + "，您可在个人账户中查看!"
                            that.rotating(successRes.data.zsIntegral);
                        }else {
                            that.toast_title = '该奖品已抽完，请明天再试！'
                            that.rotating(successRes.data.zsIntegral);
                        }
                    }
                })
            },
            //弹窗
            game_over() {
                this.toast_control = true;
            },
            //关闭弹窗
            close_toast() {
                this.toast_control = false;
                this.toast_title = ''
            }
        }
    };
</script>
<style scoped scoped>
    .container {
        width: 100%;
        height: 45.3125rem;
        padding: 0;
        background: url("../../assets/img/draw_background.png") no-repeat top center;
        background-size: 100% 100%;
        position: relative;
    }
    .lucky-wheel {
        width: 100%;
        height: 45rem;
        background:url("../../assets/img/draw_background1.png") no-repeat center bottom;
        background-size: 100%;
        /* padding-top: 1.5625rem; */
        position: absolute;
        bottom: 0;
    }

    .lucky-title {
        width: 100%;
        height: 8.125rem;
        background: url("../../assets/img/lucky_title.png") no-repeat center top;
        background-size: 100%;
    }

    .wheel-main {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        top: 14rem;
        width: 100%;
        left: 0;
    }

    .wheel-bg {
        width: 18.4375rem;
        height: 18.4375rem;
        background: url("../../assets/img/draw_roulette.png") no-repeat center top;
        background-size: 100%;
        color: #fff;
        font-weight: 500;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        transition: transform 3s ease;
    }

    .wheel-pointer-box {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 100;
        transform: translate(-50%, -60%);
        width: 4.3125rem;
        height: 5.3125rem;
    }

    .wheel-pointer {
        width: 4.3125rem;
        height: 5.3125rem;
        background: url("../../assets/img/draw_Pointer.png") no-repeat center top;
        background-size: 100%;
        transform-origin: center 60%;
    }

    .wheel-bg div {
        text-align: center;
    }

    .prize-list {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .prize-list .prize-item {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .prize-list .prize-item:first-child {
        top: 0.8rem;
        left: 6.3rem;
    }

    .prize-list .prize-item:nth-child(2) {
        top: 3.4rem;
        left: 10.6rem;
    }

    .prize-list .prize-item:nth-child(3) {
        top: 8.4rem;
        left: 11.2rem;
    }

    .prize-list .prize-item:nth-child(4) {
        top: 10.8rem;
        left: 6.2rem;
    }

    .prize-list .prize-item:nth-child(5) {
        top: 8.6rem;
        left: 1.3rem;
    }

    .prize-list .prize-item:nth-child(6) {
        top: 3.2rem;
        left: 2rem;
    }

    .prize-item {
        width: 5.875rem;
        height: 9rem;
    }

    .prize-pic img {
        width: 5rem;
        margin-top: 1.5625rem;
    }
    
    .prize-list .prize-item:nth-child(1) img{
        width: 5.4rem;
    }
    .prize-list .prize-item:nth-child(3) img{
        width: 5.2rem;
    }
    
    .prize-list .prize-item:nth-child(2) img,
    .prize-list .prize-item:nth-child(6) img{
        width: 3.8rem;
    }
    .prize-list .prize-item:nth-child(4) img{
        width: 4.2rem;
    }

    .prize-count {
        font-size: 0.875rem;
    }

    .prize-type {
        font-size: 0.75rem;
    }
    .lucky-btn{
        position: absolute;
        left: 20%;
        top: 35rem;
        width: 60%;
        height: 3rem;
        line-height: 3rem;
        text-align: center;
        font-size: 1.2rem;
        font-weight: bold;
        color: #fff;
        background: #E34643;
        border-radius: 30px;
        /* margin: 1.625rem auto; */
    }
    .btn-filter{
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
        filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    }



    .toast-mask {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 10000;
        width: 100%;
        height: 100%;
    }

    .toast {
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 20000;
        transform: translate(-50%, -50%);
        width: 15.4375rem;
        background: #fff;
        border-radius: 0.3125rem;
        padding: 0.3125rem;
        opacity: 1;
        overflow: inherit;
        background-color: rgb(252, 244, 224);
    }

    .toast-container {
        position: relative;
        width: 100%;
        height: 100%;
        border: 1px dotted #fccc6e;
    }

    .toast-picture {
        position: absolute;
        top: -6.5rem;
        left: -1.5rem;
        width: 18.75rem;
        height: 8.5625rem;
    }

    .toast-pictrue-change {
        position: absolute;
        top: -1.5rem;
        left: -1.375rem;
        width: 17.5rem;
        height: 3.125rem;
    }

    .toast-title {
        padding: 2.8125rem 0;
        font-size: 18px;
        color: #fc7939;
        text-align: center;
    }

    .toast-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.9375rem;
    }

    .toast-btn div {
        background-image: -moz-linear-gradient(
                -18deg,
                rgb(242, 148, 85) 0%,
                rgb(252, 124, 88) 51%,
                rgb(252, 124, 88) 99%
        );

        background-image: -ms-linear-gradient(
                -18deg,
                rgb(242, 148, 85) 0%,
                rgb(252, 124, 88) 51%,
                rgb(252, 124, 88) 99%
        );
        background-image: -webkit-linear-gradient(
                -18deg,
                rgb(242, 148, 85) 0%,
                rgb(252, 124, 88) 51%,
                rgb(252, 124, 88) 99%
        );
        box-shadow: 0px 4px 0px 0px rgba(174, 34, 5, 0.7);
        width: 4.6875rem;
        height: 1.875rem;
        border-radius: 1.875rem;
        text-align: center;
        line-height: 1.875rem;
        color: #fff;
    }

    .close {
        position: absolute;
        top: -0.9375rem;
        right: -0.9375rem;
        width: 2rem;
        height: 2rem;
        opacity: 1;
        background: url("../../assets/img/close_store.png") no-repeat center top;
        background-size: 100%;
    }
</style>

